import React from 'react';
import { Button, Circle } from '@icecreamsocial/components';
import { CloseIcon } from '../SupportedIcons';

/**
 * @promote to library
 * @param {*} param0
 * @returns
 */
const CloseButton = ({ ...rest }) => (
	<Circle
		as={Button}
		type="button"
		aria-label="Close"
		padding="none"
		backgroundColor="transparent"
		textColor="body"
		shadow="none"
		{...rest}
	>
		<CloseIcon style={{ pointerEvents: 'none' }} />
	</Circle>
);
CloseButton.displayName = 'CloseButton';

export default CloseButton;
